import { initialNavigationState } from '@store/hookstate/navigation/navigation';
import { deviceTypes } from '@styles/mediaQueries';
import { IViewport } from '@utils/getViewport';
import styled from 'styled-components';

interface IContainer {
  'data-viewport': IViewport;
}
export const Container = styled.div<IContainer>`
  /* This changes. */
  --line-height: ${initialNavigationState.offsetTop}px;
  --sidebar-width-closed: ${initialNavigationState.minLeft}px;

  --vhunit: ${({ 'data-viewport': vp }) => vp.height / 100}px;
  --vwunit: ${({ 'data-viewport': vp }) => vp.width / 100}px;
  --100vh: calc(100 * var(--vhunit));

  /* This stays. */
  --sidebar-width-expanded: ${initialNavigationState.maxLeft}px;
  --sidebar-width: ${initialNavigationState.minLeft}px;

  [data-device='${deviceTypes.mobile}'] & {
    --sidebar-width-closed: 0px;
    --line-height: 0px;
  }

  height: var(--100vh);
  position: relative;
  /* Scrolls page. */
  overflow-x: hidden;
`;

export const SearchBarContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;

  [data-device='${deviceTypes.mobile}'] & {
    display: none;
  }
`;

export const SidebarContainer = styled.div`
  --offset-top: var(--line-height);

  position: fixed;
  left: 0;
  top: var(--offset-top);
  height: calc(100% - var(--offset-top));
  z-index: 10;
`;

export const Content = styled.div`
  padding-top: var(--line-height);
  padding-left: var(--sidebar-width-closed);
  z-index: 9;
  max-height: var(--100vh);
  height: 100%;

  /* Unset transition for padding changes */
  transition: unset;
`;

export const TicketContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 32px;
  box-shadow: 0px 1px 4px 0px #00000029;
  padding: 16px 24px;
  border-radius: 8px 8px 0 0;
  background: #fff;
`;
